export default "__VITE_ASSET__27a6e87e__"